import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const RefreshIcon = createIcon(
  'Refresh',
  <path d="M55.5212678,6.46810698 C54.6154145,5.56225374 53.372209,5 51.9915637,5 C49.2302732,5 47,7.23652042 47,9.997811 C47,12.7591016 49.2302732,14.995622 51.9915637,14.995622 C54.3217931,14.995622 56.2646921,13.4025697 56.8206986,11.2472637 L55.5212678,11.2472637 C55.0089921,12.7028762 53.6220996,13.7461692 51.9915637,13.7461692 C49.9237194,13.7461692 48.2432055,12.0656553 48.2432055,9.997811 C48.2432055,7.9299667 49.9237194,6.24945275 51.9915637,6.24945275 C53.0286095,6.24945275 53.9532046,6.68051395 54.627909,7.3614657 L52.6162901,9.37308462 L56.9893747,9.37308462 L56.9893747,5 L55.5212678,6.46810698 L55.5212678,6.46810698 Z" />,
  { viewBox: '46 4 12 12' }
);

RefreshIcon.warning = true;

export default RefreshIcon;
